import { ApiCrud } from 'adready-api/api/api-crud';
import http from 'adready-api/api/http';

const reportBuilderV2API = new ApiCrud(http.AXIOS, {
  runReport: 'POST ac/advertisers/:advertiserId/reportTemplate/run',
  runPresetReport: 'POST ac/advertisers/:advertiserId/reportTemplate/preset/run',
  createReportTemplate: 'POST ac/advertisers/:advertiserId/reportTemplate',

  toggleStatus: 'PUT ac/advertisers/:advertiserId/reportTemplate/:id',
  updateReportTemplate: 'PUT ac/advertisers/:advertiserId/reportTemplate/:id',
  deleteReport: 'DELETE ac/advertisers/:advertiserId/reportTemplate/:id',
  getScheduledReportStatus: 'GET ac/advertisers/:advertiserId/reportTemplate/:id',
  getScheduledReportLast5RunStatus:
    'GET ac/advertisers/:advertiserId/reportTemplate/:id/reportGenerationLogs',
});
export default reportBuilderV2API;
